import React, { useState } from "react"
import ModalCustom from "../../../../../components/ModalCustom"
import alertSvg from "../../../../../images/alert.svg"

export default function ModalOfficializationOfResults({
  isVisible,
  onCancel,
  isLoading,
  officializeWatcher,
  isAmbassador,
  measure,
}) {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)

  React.useEffect(() => {
    setIsModalVisible(isVisible)
    setIsLoadingModal(isLoading)
  }, [])

  return (
    <ModalCustom
      modalOpen={isModalVisible}
      showFooter
      onCancel={() => onCancel()}
      isLoadingButton={isLoadingModal}
      onOk={() => {
        officializeWatcher(measure)
      }}>
      <img src={alertSvg} className="alertIcon" />
      <span style={{ fontSize: 14, fontWeight: 600 }}>
        ¿Estás seguro de que deseas oficializar los resultados?
      </span>
      {isAmbassador ? (
        <div style={{ fontSize: 13, marginTop: 15, textAlign: "left" }}>
          <p>La oficialización hara qué: </p>
          <p>
            1. La encuesta se <strong>cierre permanentemente</strong> con la
            información recolectada hasta el momento (ya no podrán realizarse
            cambios 😱).
          </p>
          <p>
            2. Los resultados se compartan con los embajadores de las divisiones
            por correo y en el sistema.
          </p>
        </div>
      ) : (
        <p style={{ fontSize: 13, marginTop: 8 }}>
          La encuesta se <strong>cerrará permanentemente</strong> con la
          información recolectada hasta el momento y ya no podrán realizarse
          cambios (😱).
        </p>
      )}
    </ModalCustom>
  )
}
